"use strict";

require("core-js/modules/es6.array.filter.js");
var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$keys2 = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
require("core-js/modules/es6.string.small.js");
require("core-js/modules/es6.number.constructor.js");
require("core-js/modules/es6.array.slice.js");
require("core-js/modules/es6.regexp.split.js");
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _get_month = _interopRequireDefault(require("date-fns/get_month"));
var _get_year = _interopRequireDefault(require("date-fns/get_year"));
var _is_before = _interopRequireDefault(require("date-fns/is_before"));
var _gridStyled = require("grid-styled");
var _get = _interopRequireDefault(require("lodash/get"));
var _calendar = require("@gravity/calendar");
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _calendar2 = require("@nucleo/calendar");
var _product = require("@nucleo/product");
var _jsxFileName = "/codebuild/output/src2586451875/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/OccurrenceCalendar/lib/OccurrenceCalendar.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_1sbdg4za2() {
  var path = "/codebuild/output/src2586451875/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/OccurrenceCalendar/lib/OccurrenceCalendar.js";
  var hash = "ce2c11ee1892627429b5e6abd95cf1d48868781e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src2586451875/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/OccurrenceCalendar/lib/OccurrenceCalendar.js",
    statementMap: {
      "0": {
        start: {
          line: 22,
          column: 33
        },
        end: {
          line: 22,
          column: 49
        }
      },
      "1": {
        start: {
          line: 24,
          column: 16
        },
        end: {
          line: 29,
          column: 1
        }
      },
      "2": {
        start: {
          line: 25,
          column: 22
        },
        end: {
          line: 25,
          column: 88
        }
      },
      "3": {
        start: {
          line: 31,
          column: 22
        },
        end: {
          line: 36,
          column: 1
        }
      },
      "4": {
        start: {
          line: 37,
          column: 20
        },
        end: {
          line: 56,
          column: 1
        }
      },
      "5": {
        start: {
          line: 59,
          column: 22
        },
        end: {
          line: 59,
          column: 54
        }
      },
      "6": {
        start: {
          line: 61,
          column: 16
        },
        end: {
          line: 67,
          column: 1
        }
      },
      "7": {
        start: {
          line: 62,
          column: 13
        },
        end: {
          line: 64,
          column: 43
        }
      },
      "8": {
        start: {
          line: 66,
          column: 2
        },
        end: {
          line: 66,
          column: 93
        }
      },
      "9": {
        start: {
          line: 69,
          column: 24
        },
        end: {
          line: 75,
          column: 1
        }
      },
      "10": {
        start: {
          line: 72,
          column: 33
        },
        end: {
          line: 72,
          column: 44
        }
      },
      "11": {
        start: {
          line: 77,
          column: 28
        },
        end: {
          line: 82,
          column: 1
        }
      },
      "12": {
        start: {
          line: 78,
          column: 22
        },
        end: {
          line: 78,
          column: 33
        }
      },
      "13": {
        start: {
          line: 84,
          column: 18
        },
        end: {
          line: 90,
          column: 1
        }
      },
      "14": {
        start: {
          line: 88,
          column: 14
        },
        end: {
          line: 88,
          column: 72
        }
      },
      "15": {
        start: {
          line: 89,
          column: 20
        },
        end: {
          line: 89,
          column: 97
        }
      },
      "16": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 113,
          column: 5
        }
      },
      "17": {
        start: {
          line: 96,
          column: 20
        },
        end: {
          line: 96,
          column: 61
        }
      },
      "18": {
        start: {
          line: 97,
          column: 24
        },
        end: {
          line: 97,
          column: 32
        }
      },
      "19": {
        start: {
          line: 98,
          column: 23
        },
        end: {
          line: 98,
          column: 34
        }
      },
      "20": {
        start: {
          line: 99,
          column: 25
        },
        end: {
          line: 99,
          column: 81
        }
      },
      "21": {
        start: {
          line: 100,
          column: 6
        },
        end: {
          line: 105,
          column: 7
        }
      },
      "22": {
        start: {
          line: 101,
          column: 8
        },
        end: {
          line: 104,
          column: 10
        }
      },
      "23": {
        start: {
          line: 106,
          column: 24
        },
        end: {
          line: 106,
          column: 88
        }
      },
      "24": {
        start: {
          line: 107,
          column: 6
        },
        end: {
          line: 112,
          column: 7
        }
      },
      "25": {
        start: {
          line: 108,
          column: 8
        },
        end: {
          line: 111,
          column: 10
        }
      },
      "26": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 114,
          column: 17
        }
      },
      "27": {
        start: {
          line: 118,
          column: 4
        },
        end: {
          line: 118,
          column: 17
        }
      },
      "28": {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 121,
          column: 6
        }
      },
      "29": {
        start: {
          line: 122,
          column: 4
        },
        end: {
          line: 122,
          column: 51
        }
      },
      "30": {
        start: {
          line: 123,
          column: 4
        },
        end: {
          line: 123,
          column: 49
        }
      },
      "31": {
        start: {
          line: 131,
          column: 4
        },
        end: {
          line: 131,
          column: 32
        }
      },
      "32": {
        start: {
          line: 136,
          column: 6
        },
        end: {
          line: 137,
          column: 77
        }
      },
      "33": {
        start: {
          line: 138,
          column: 4
        },
        end: {
          line: 138,
          column: 79
        }
      },
      "34": {
        start: {
          line: 142,
          column: 20
        },
        end: {
          line: 142,
          column: 37
        }
      },
      "35": {
        start: {
          line: 143,
          column: 4
        },
        end: {
          line: 143,
          column: 68
        }
      },
      "36": {
        start: {
          line: 147,
          column: 20
        },
        end: {
          line: 147,
          column: 37
        }
      },
      "37": {
        start: {
          line: 148,
          column: 4
        },
        end: {
          line: 148,
          column: 64
        }
      },
      "38": {
        start: {
          line: 156,
          column: 18
        },
        end: {
          line: 156,
          column: 64
        }
      },
      "39": {
        start: {
          line: 157,
          column: 22
        },
        end: {
          line: 157,
          column: 38
        }
      },
      "40": {
        start: {
          line: 158,
          column: 21
        },
        end: {
          line: 158,
          column: 40
        }
      },
      "41": {
        start: {
          line: 159,
          column: 20
        },
        end: {
          line: 159,
          column: 38
        }
      },
      "42": {
        start: {
          line: 160,
          column: 23
        },
        end: {
          line: 160,
          column: 63
        }
      },
      "43": {
        start: {
          line: 161,
          column: 22
        },
        end: {
          line: 161,
          column: 72
        }
      },
      "44": {
        start: {
          line: 162,
          column: 21
        },
        end: {
          line: 162,
          column: 40
        }
      },
      "45": {
        start: {
          line: 163,
          column: 4
        },
        end: {
          line: 173,
          column: 5
        }
      },
      "46": {
        start: {
          line: 164,
          column: 6
        },
        end: {
          line: 164,
          column: 29
        }
      },
      "47": {
        start: {
          line: 165,
          column: 11
        },
        end: {
          line: 173,
          column: 5
        }
      },
      "48": {
        start: {
          line: 166,
          column: 6
        },
        end: {
          line: 166,
          column: 25
        }
      },
      "49": {
        start: {
          line: 168,
          column: 6
        },
        end: {
          line: 168,
          column: 40
        }
      },
      "50": {
        start: {
          line: 169,
          column: 6
        },
        end: {
          line: 172,
          column: 9
        }
      },
      "51": {
        start: {
          line: 177,
          column: 59
        },
        end: {
          line: 177,
          column: 69
        }
      },
      "52": {
        start: {
          line: 178,
          column: 23
        },
        end: {
          line: 178,
          column: 28
        }
      },
      "53": {
        start: {
          line: 180,
          column: 6
        },
        end: {
          line: 181,
          column: 77
        }
      },
      "54": {
        start: {
          line: 183,
          column: 24
        },
        end: {
          line: 183,
          column: 64
        }
      },
      "55": {
        start: {
          line: 186,
          column: 27
        },
        end: {
          line: 186,
          column: 32
        }
      },
      "56": {
        start: {
          line: 187,
          column: 26
        },
        end: {
          line: 187,
          column: 31
        }
      },
      "57": {
        start: {
          line: 189,
          column: 20
        },
        end: {
          line: 189,
          column: 44
        }
      },
      "58": {
        start: {
          line: 192,
          column: 18
        },
        end: {
          line: 192,
          column: 20
        }
      },
      "59": {
        start: {
          line: 193,
          column: 4
        },
        end: {
          line: 244,
          column: 5
        }
      },
      "60": {
        start: {
          line: 194,
          column: 20
        },
        end: {
          line: 194,
          column: 25
        }
      },
      "61": {
        start: {
          line: 195,
          column: 6
        },
        end: {
          line: 208,
          column: 7
        }
      },
      "62": {
        start: {
          line: 196,
          column: 8
        },
        end: {
          line: 196,
          column: 23
        }
      },
      "63": {
        start: {
          line: 197,
          column: 8
        },
        end: {
          line: 201,
          column: 11
        }
      },
      "64": {
        start: {
          line: 198,
          column: 10
        },
        end: {
          line: 200,
          column: 13
        }
      },
      "65": {
        start: {
          line: 199,
          column: 12
        },
        end: {
          line: 199,
          column: 90
        }
      },
      "66": {
        start: {
          line: 202,
          column: 13
        },
        end: {
          line: 208,
          column: 7
        }
      },
      "67": {
        start: {
          line: 203,
          column: 8
        },
        end: {
          line: 207,
          column: 11
        }
      },
      "68": {
        start: {
          line: 204,
          column: 10
        },
        end: {
          line: 206,
          column: 13
        }
      },
      "69": {
        start: {
          line: 205,
          column: 12
        },
        end: {
          line: 205,
          column: 81
        }
      },
      "70": {
        start: {
          line: 209,
          column: 26
        },
        end: {
          line: 209,
          column: 62
        }
      },
      "71": {
        start: {
          line: 210,
          column: 21
        },
        end: {
          line: 210,
          column: 57
        }
      },
      "72": {
        start: {
          line: 212,
          column: 6
        },
        end: {
          line: 214,
          column: 7
        }
      },
      "73": {
        start: {
          line: 213,
          column: 8
        },
        end: {
          line: 213,
          column: 41
        }
      },
      "74": {
        start: {
          line: 215,
          column: 6
        },
        end: {
          line: 241,
          column: 9
        }
      },
      "75": {
        start: {
          line: 216,
          column: 22
        },
        end: {
          line: 216,
          column: 31
        }
      },
      "76": {
        start: {
          line: 217,
          column: 21
        },
        end: {
          line: 217,
          column: 62
        }
      },
      "77": {
        start: {
          line: 218,
          column: 27
        },
        end: {
          line: 218,
          column: 68
        }
      },
      "78": {
        start: {
          line: 219,
          column: 29
        },
        end: {
          line: 219,
          column: 40
        }
      },
      "79": {
        start: {
          line: 220,
          column: 33
        },
        end: {
          line: 220,
          column: 50
        }
      },
      "80": {
        start: {
          line: 221,
          column: 8
        },
        end: {
          line: 221,
          column: 67
        }
      },
      "81": {
        start: {
          line: 222,
          column: 8
        },
        end: {
          line: 222,
          column: 56
        }
      },
      "82": {
        start: {
          line: 223,
          column: 8
        },
        end: {
          line: 240,
          column: 9
        }
      },
      "83": {
        start: {
          line: 224,
          column: 10
        },
        end: {
          line: 230,
          column: 12
        }
      },
      "84": {
        start: {
          line: 232,
          column: 10
        },
        end: {
          line: 232,
          column: 37
        }
      },
      "85": {
        start: {
          line: 233,
          column: 10
        },
        end: {
          line: 233,
          column: 87
        }
      },
      "86": {
        start: {
          line: 235,
          column: 10
        },
        end: {
          line: 238,
          column: 39
        }
      },
      "87": {
        start: {
          line: 239,
          column: 10
        },
        end: {
          line: 239,
          column: 87
        }
      },
      "88": {
        start: {
          line: 242,
          column: 6
        },
        end: {
          line: 242,
          column: 72
        }
      },
      "89": {
        start: {
          line: 243,
          column: 6
        },
        end: {
          line: 243,
          column: 67
        }
      },
      "90": {
        start: {
          line: 246,
          column: 29
        },
        end: {
          line: 273,
          column: 5
        }
      },
      "91": {
        start: {
          line: 247,
          column: 6
        },
        end: {
          line: 272,
          column: 8
        }
      },
      "92": {
        start: {
          line: 275,
          column: 4
        },
        end: {
          line: 294,
          column: 6
        }
      },
      "93": {
        start: {
          line: 298,
          column: 0
        },
        end: {
          line: 322,
          column: 2
        }
      },
      "94": {
        start: {
          line: 324,
          column: 0
        },
        end: {
          line: 334,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 25,
            column: 13
          },
          end: {
            line: 25,
            column: 14
          }
        },
        loc: {
          start: {
            line: 25,
            column: 22
          },
          end: {
            line: 25,
            column: 88
          }
        },
        line: 25
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 61,
            column: 16
          },
          end: {
            line: 61,
            column: 17
          }
        },
        loc: {
          start: {
            line: 61,
            column: 45
          },
          end: {
            line: 67,
            column: 1
          }
        },
        line: 61
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 72,
            column: 24
          },
          end: {
            line: 72,
            column: 25
          }
        },
        loc: {
          start: {
            line: 72,
            column: 33
          },
          end: {
            line: 72,
            column: 44
          }
        },
        line: 72
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 78,
            column: 13
          },
          end: {
            line: 78,
            column: 14
          }
        },
        loc: {
          start: {
            line: 78,
            column: 22
          },
          end: {
            line: 78,
            column: 33
          }
        },
        line: 78
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 88,
            column: 5
          }
        },
        loc: {
          start: {
            line: 88,
            column: 14
          },
          end: {
            line: 88,
            column: 72
          }
        },
        line: 88
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 89,
            column: 11
          },
          end: {
            line: 89,
            column: 12
          }
        },
        loc: {
          start: {
            line: 89,
            column: 20
          },
          end: {
            line: 89,
            column: 97
          }
        },
        line: 89
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 93,
            column: 2
          },
          end: {
            line: 93,
            column: 3
          }
        },
        loc: {
          start: {
            line: 93,
            column: 48
          },
          end: {
            line: 115,
            column: 3
          }
        },
        line: 93
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 117,
            column: 2
          },
          end: {
            line: 117,
            column: 3
          }
        },
        loc: {
          start: {
            line: 117,
            column: 21
          },
          end: {
            line: 124,
            column: 3
          }
        },
        line: 117
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 130,
            column: 2
          },
          end: {
            line: 130,
            column: 3
          }
        },
        loc: {
          start: {
            line: 130,
            column: 19
          },
          end: {
            line: 132,
            column: 3
          }
        },
        line: 130
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 134,
            column: 2
          },
          end: {
            line: 134,
            column: 3
          }
        },
        loc: {
          start: {
            line: 134,
            column: 15
          },
          end: {
            line: 139,
            column: 3
          }
        },
        line: 134
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 141,
            column: 2
          },
          end: {
            line: 141,
            column: 3
          }
        },
        loc: {
          start: {
            line: 141,
            column: 26
          },
          end: {
            line: 144,
            column: 3
          }
        },
        line: 141
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 146,
            column: 2
          },
          end: {
            line: 146,
            column: 3
          }
        },
        loc: {
          start: {
            line: 146,
            column: 22
          },
          end: {
            line: 149,
            column: 3
          }
        },
        line: 146
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 155,
            column: 2
          },
          end: {
            line: 155,
            column: 3
          }
        },
        loc: {
          start: {
            line: 155,
            column: 25
          },
          end: {
            line: 174,
            column: 3
          }
        },
        line: 155
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 176,
            column: 2
          },
          end: {
            line: 176,
            column: 3
          }
        },
        loc: {
          start: {
            line: 176,
            column: 11
          },
          end: {
            line: 295,
            column: 3
          }
        },
        line: 176
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 197,
            column: 33
          },
          end: {
            line: 197,
            column: 34
          }
        },
        loc: {
          start: {
            line: 197,
            column: 44
          },
          end: {
            line: 201,
            column: 9
          }
        },
        line: 197
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 198,
            column: 32
          },
          end: {
            line: 198,
            column: 33
          }
        },
        loc: {
          start: {
            line: 198,
            column: 40
          },
          end: {
            line: 200,
            column: 11
          }
        },
        line: 198
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 203,
            column: 33
          },
          end: {
            line: 203,
            column: 34
          }
        },
        loc: {
          start: {
            line: 203,
            column: 44
          },
          end: {
            line: 207,
            column: 9
          }
        },
        line: 203
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 204,
            column: 32
          },
          end: {
            line: 204,
            column: 33
          }
        },
        loc: {
          start: {
            line: 204,
            column: 40
          },
          end: {
            line: 206,
            column: 11
          }
        },
        line: 204
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 215,
            column: 26
          },
          end: {
            line: 215,
            column: 27
          }
        },
        loc: {
          start: {
            line: 215,
            column: 33
          },
          end: {
            line: 241,
            column: 7
          }
        },
        line: 215
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 246,
            column: 29
          },
          end: {
            line: 246,
            column: 30
          }
        },
        loc: {
          start: {
            line: 246,
            column: 35
          },
          end: {
            line: 273,
            column: 5
          }
        },
        line: 246
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 62,
            column: 13
          },
          end: {
            line: 64,
            column: 43
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 63,
            column: 46
          }
        }, {
          start: {
            line: 64,
            column: 6
          },
          end: {
            line: 64,
            column: 43
          }
        }],
        line: 62
      },
      "1": {
        loc: {
          start: {
            line: 66,
            column: 42
          },
          end: {
            line: 66,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 66,
            column: 57
          },
          end: {
            line: 66,
            column: 60
          }
        }, {
          start: {
            line: 66,
            column: 63
          },
          end: {
            line: 66,
            column: 65
          }
        }],
        line: 66
      },
      "2": {
        loc: {
          start: {
            line: 88,
            column: 14
          },
          end: {
            line: 88,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 88,
            column: 29
          },
          end: {
            line: 88,
            column: 44
          }
        }, {
          start: {
            line: 88,
            column: 47
          },
          end: {
            line: 88,
            column: 72
          }
        }],
        line: 88
      },
      "3": {
        loc: {
          start: {
            line: 89,
            column: 20
          },
          end: {
            line: 89,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 89,
            column: 20
          },
          end: {
            line: 89,
            column: 31
          }
        }, {
          start: {
            line: 89,
            column: 35
          },
          end: {
            line: 89,
            column: 56
          }
        }, {
          start: {
            line: 89,
            column: 60
          },
          end: {
            line: 89,
            column: 97
          }
        }],
        line: 89
      },
      "4": {
        loc: {
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 95
      },
      "5": {
        loc: {
          start: {
            line: 95,
            column: 8
          },
          end: {
            line: 95,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 95,
            column: 8
          },
          end: {
            line: 95,
            column: 22
          }
        }, {
          start: {
            line: 95,
            column: 26
          },
          end: {
            line: 95,
            column: 47
          }
        }],
        line: 95
      },
      "6": {
        loc: {
          start: {
            line: 100,
            column: 6
          },
          end: {
            line: 105,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 100,
            column: 6
          },
          end: {
            line: 105,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 100
      },
      "7": {
        loc: {
          start: {
            line: 107,
            column: 6
          },
          end: {
            line: 112,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 107,
            column: 6
          },
          end: {
            line: 112,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 107
      },
      "8": {
        loc: {
          start: {
            line: 136,
            column: 6
          },
          end: {
            line: 137,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 136,
            column: 6
          },
          end: {
            line: 136,
            column: 40
          }
        }, {
          start: {
            line: 137,
            column: 6
          },
          end: {
            line: 137,
            column: 77
          }
        }],
        line: 136
      },
      "9": {
        loc: {
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 173,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 173,
            column: 5
          }
        }, {
          start: {
            line: 165,
            column: 11
          },
          end: {
            line: 173,
            column: 5
          }
        }],
        line: 163
      },
      "10": {
        loc: {
          start: {
            line: 163,
            column: 8
          },
          end: {
            line: 163,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 163,
            column: 8
          },
          end: {
            line: 163,
            column: 27
          }
        }, {
          start: {
            line: 163,
            column: 32
          },
          end: {
            line: 163,
            column: 53
          }
        }, {
          start: {
            line: 163,
            column: 57
          },
          end: {
            line: 163,
            column: 78
          }
        }],
        line: 163
      },
      "11": {
        loc: {
          start: {
            line: 165,
            column: 11
          },
          end: {
            line: 173,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 165,
            column: 11
          },
          end: {
            line: 173,
            column: 5
          }
        }, {
          start: {
            line: 167,
            column: 11
          },
          end: {
            line: 173,
            column: 5
          }
        }],
        line: 165
      },
      "12": {
        loc: {
          start: {
            line: 165,
            column: 15
          },
          end: {
            line: 165,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 165,
            column: 15
          },
          end: {
            line: 165,
            column: 33
          }
        }, {
          start: {
            line: 165,
            column: 38
          },
          end: {
            line: 165,
            column: 58
          }
        }, {
          start: {
            line: 165,
            column: 62
          },
          end: {
            line: 165,
            column: 82
          }
        }],
        line: 165
      },
      "13": {
        loc: {
          start: {
            line: 177,
            column: 12
          },
          end: {
            line: 177,
            column: 54
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 177,
            column: 27
          },
          end: {
            line: 177,
            column: 54
          }
        }],
        line: 177
      },
      "14": {
        loc: {
          start: {
            line: 180,
            column: 6
          },
          end: {
            line: 181,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 180,
            column: 6
          },
          end: {
            line: 180,
            column: 40
          }
        }, {
          start: {
            line: 181,
            column: 6
          },
          end: {
            line: 181,
            column: 77
          }
        }],
        line: 180
      },
      "15": {
        loc: {
          start: {
            line: 193,
            column: 4
          },
          end: {
            line: 244,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 193,
            column: 4
          },
          end: {
            line: 244,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 193
      },
      "16": {
        loc: {
          start: {
            line: 195,
            column: 6
          },
          end: {
            line: 208,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 195,
            column: 6
          },
          end: {
            line: 208,
            column: 7
          }
        }, {
          start: {
            line: 202,
            column: 13
          },
          end: {
            line: 208,
            column: 7
          }
        }],
        line: 195
      },
      "17": {
        loc: {
          start: {
            line: 195,
            column: 10
          },
          end: {
            line: 195,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 195,
            column: 10
          },
          end: {
            line: 195,
            column: 30
          }
        }, {
          start: {
            line: 195,
            column: 34
          },
          end: {
            line: 195,
            column: 65
          }
        }],
        line: 195
      },
      "18": {
        loc: {
          start: {
            line: 202,
            column: 13
          },
          end: {
            line: 208,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 202,
            column: 13
          },
          end: {
            line: 208,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 202
      },
      "19": {
        loc: {
          start: {
            line: 202,
            column: 17
          },
          end: {
            line: 202,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 202,
            column: 17
          },
          end: {
            line: 202,
            column: 34
          }
        }, {
          start: {
            line: 202,
            column: 38
          },
          end: {
            line: 202,
            column: 66
          }
        }],
        line: 202
      },
      "20": {
        loc: {
          start: {
            line: 210,
            column: 21
          },
          end: {
            line: 210,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 210,
            column: 21
          },
          end: {
            line: 210,
            column: 35
          }
        }, {
          start: {
            line: 210,
            column: 39
          },
          end: {
            line: 210,
            column: 57
          }
        }],
        line: 210
      },
      "21": {
        loc: {
          start: {
            line: 212,
            column: 6
          },
          end: {
            line: 214,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 212,
            column: 6
          },
          end: {
            line: 214,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 212
      },
      "22": {
        loc: {
          start: {
            line: 221,
            column: 20
          },
          end: {
            line: 221,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 221,
            column: 49
          },
          end: {
            line: 221,
            column: 58
          }
        }, {
          start: {
            line: 221,
            column: 61
          },
          end: {
            line: 221,
            column: 66
          }
        }],
        line: 221
      },
      "23": {
        loc: {
          start: {
            line: 222,
            column: 23
          },
          end: {
            line: 222,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 222,
            column: 23
          },
          end: {
            line: 222,
            column: 35
          }
        }, {
          start: {
            line: 222,
            column: 39
          },
          end: {
            line: 222,
            column: 55
          }
        }],
        line: 222
      },
      "24": {
        loc: {
          start: {
            line: 223,
            column: 8
          },
          end: {
            line: 240,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 223,
            column: 8
          },
          end: {
            line: 240,
            column: 9
          }
        }, {
          start: {
            line: 231,
            column: 15
          },
          end: {
            line: 240,
            column: 9
          }
        }],
        line: 223
      },
      "25": {
        loc: {
          start: {
            line: 226,
            column: 20
          },
          end: {
            line: 226,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 226,
            column: 20
          },
          end: {
            line: 226,
            column: 26
          }
        }, {
          start: {
            line: 226,
            column: 30
          },
          end: {
            line: 226,
            column: 68
          }
        }],
        line: 226
      },
      "26": {
        loc: {
          start: {
            line: 227,
            column: 21
          },
          end: {
            line: 227,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 227,
            column: 40
          },
          end: {
            line: 227,
            column: 51
          }
        }, {
          start: {
            line: 227,
            column: 54
          },
          end: {
            line: 227,
            column: 56
          }
        }],
        line: 227
      },
      "27": {
        loc: {
          start: {
            line: 236,
            column: 12
          },
          end: {
            line: 238,
            column: 38
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 237,
            column: 16
          },
          end: {
            line: 237,
            column: 32
          }
        }, {
          start: {
            line: 238,
            column: 16
          },
          end: {
            line: 238,
            column: 38
          }
        }],
        line: 236
      },
      "28": {
        loc: {
          start: {
            line: 239,
            column: 33
          },
          end: {
            line: 239,
            column: 86
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 239,
            column: 52
          },
          end: {
            line: 239,
            column: 63
          }
        }, {
          start: {
            line: 239,
            column: 66
          },
          end: {
            line: 239,
            column: 86
          }
        }],
        line: 239
      },
      "29": {
        loc: {
          start: {
            line: 250,
            column: 13
          },
          end: {
            line: 250,
            column: 101
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 250,
            column: 13
          },
          end: {
            line: 250,
            column: 57
          }
        }, {
          start: {
            line: 250,
            column: 62
          },
          end: {
            line: 250,
            column: 100
          }
        }],
        line: 250
      },
      "30": {
        loc: {
          start: {
            line: 251,
            column: 13
          },
          end: {
            line: 251,
            column: 124
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 251,
            column: 13
          },
          end: {
            line: 251,
            column: 55
          }
        }, {
          start: {
            line: 251,
            column: 60
          },
          end: {
            line: 251,
            column: 123
          }
        }],
        line: 251
      },
      "31": {
        loc: {
          start: {
            line: 255,
            column: 13
          },
          end: {
            line: 255,
            column: 104
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 255,
            column: 13
          },
          end: {
            line: 255,
            column: 57
          }
        }, {
          start: {
            line: 255,
            column: 62
          },
          end: {
            line: 255,
            column: 103
          }
        }],
        line: 255
      },
      "32": {
        loc: {
          start: {
            line: 256,
            column: 13
          },
          end: {
            line: 256,
            column: 127
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 256,
            column: 13
          },
          end: {
            line: 256,
            column: 55
          }
        }, {
          start: {
            line: 256,
            column: 60
          },
          end: {
            line: 256,
            column: 126
          }
        }],
        line: 256
      },
      "33": {
        loc: {
          start: {
            line: 260,
            column: 13
          },
          end: {
            line: 260,
            column: 101
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 260,
            column: 13
          },
          end: {
            line: 260,
            column: 57
          }
        }, {
          start: {
            line: 260,
            column: 62
          },
          end: {
            line: 260,
            column: 100
          }
        }],
        line: 260
      },
      "34": {
        loc: {
          start: {
            line: 261,
            column: 13
          },
          end: {
            line: 261,
            column: 128
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 261,
            column: 13
          },
          end: {
            line: 261,
            column: 55
          }
        }, {
          start: {
            line: 261,
            column: 60
          },
          end: {
            line: 261,
            column: 127
          }
        }],
        line: 261
      },
      "35": {
        loc: {
          start: {
            line: 264,
            column: 11
          },
          end: {
            line: 264,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 264,
            column: 11
          },
          end: {
            line: 264,
            column: 55
          }
        }, {
          start: {
            line: 264,
            column: 59
          },
          end: {
            line: 264,
            column: 74
          }
        }],
        line: 264
      },
      "36": {
        loc: {
          start: {
            line: 265,
            column: 11
          },
          end: {
            line: 270,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 265,
            column: 11
          },
          end: {
            line: 265,
            column: 23
          }
        }, {
          start: {
            line: 266,
            column: 12
          },
          end: {
            line: 269,
            column: 26
          }
        }],
        line: 265
      },
      "37": {
        loc: {
          start: {
            line: 277,
            column: 28
          },
          end: {
            line: 277,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 277,
            column: 28
          },
          end: {
            line: 277,
            column: 35
          }
        }, {
          start: {
            line: 277,
            column: 39
          },
          end: {
            line: 277,
            column: 49
          }
        }],
        line: 277
      },
      "38": {
        loc: {
          start: {
            line: 285,
            column: 21
          },
          end: {
            line: 285,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 285,
            column: 45
          },
          end: {
            line: 285,
            column: 60
          }
        }, {
          start: {
            line: 285,
            column: 63
          },
          end: {
            line: 285,
            column: 72
          }
        }],
        line: 285
      },
      "39": {
        loc: {
          start: {
            line: 288,
            column: 11
          },
          end: {
            line: 290,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 288,
            column: 11
          },
          end: {
            line: 288,
            column: 33
          }
        }, {
          start: {
            line: 289,
            column: 12
          },
          end: {
            line: 289,
            column: 56
          }
        }, {
          start: {
            line: 290,
            column: 12
          },
          end: {
            line: 290,
            column: 30
          }
        }],
        line: 288
      },
      "40": {
        loc: {
          start: {
            line: 292,
            column: 9
          },
          end: {
            line: 292,
            column: 99
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 292,
            column: 9
          },
          end: {
            line: 292,
            column: 31
          }
        }, {
          start: {
            line: 292,
            column: 35
          },
          end: {
            line: 292,
            column: 77
          }
        }, {
          start: {
            line: 292,
            column: 81
          },
          end: {
            line: 292,
            column: 99
          }
        }],
        line: 292
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0, 0],
      "11": [0, 0],
      "12": [0, 0, 0],
      "13": [0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0, 0],
      "40": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ce2c11ee1892627429b5e6abd95cf1d48868781e"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1sbdg4za2 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1sbdg4za2();
function ownKeys(e, r) { var t = _Object$keys2(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var _ref = (cov_1sbdg4za2().s[0]++, _stylingConstants.default),
  color = _ref.color,
  spacing = _ref.spacing,
  font = _ref.font;
var Wrapper = (cov_1sbdg4za2().s[1]++, (0, _styledComponents.default)(_gridStyled.Flex).attrs({
  className: function className(props) {
    cov_1sbdg4za2().f[0]++;
    cov_1sbdg4za2().s[2]++;
    return "stx-OccurrenceCalendar stx-OccurrenceCalendar-".concat(props.productid);
  }
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  height: 100%;\n"]))));
var LegendWrapper = (cov_1sbdg4za2().s[3]++, (0, _styledComponents.default)(_gridStyled.Flex).attrs({
  className: 'stx-OccurrenceCalendar-legend'
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  flex-direction: column;\n  padding-left: ", ";\n"])), spacing.small));
var LegendEntry = (cov_1sbdg4za2().s[4]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Box).attrs({
  className: 'stx-OccurrenceCalendar-legendEntry'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n      min-height: ", ";\n      font-size: ", ";\n    "])), font.sizeXs, font.sizeS)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n      padding: 5px 0px;\n      font-size: ", ";\n      font-weight: 500;\n      line-height: ", ";\n      .g-mini-calendar-content .g-Icon-grade{\n        margin-right: 4px;\n      }\n    "])), _themeMapper.evolutionTheme.typography.caption1.fontSize, _themeMapper.evolutionTheme.typography.caption1.lineHeight))));

// Use this table to define the priority.
var priorityAvail = (cov_1sbdg4za2().s[5]++, {
  NONE: 1,
  LIMITED: 2,
  GOOD: 3
});
cov_1sbdg4za2().s[6]++;
var getInfo = function getInfo(intl, quantity, isEvent) {
  cov_1sbdg4za2().f[1]++;
  var id = (cov_1sbdg4za2().s[7]++, isEvent ? (cov_1sbdg4za2().b[0][0]++, 'gravity.OccurrenceCalendar.performance') : (cov_1sbdg4za2().b[0][1]++, 'gravity.OccurrenceCalendar.timeslot'));
  cov_1sbdg4za2().s[8]++;
  return intl.formatMessage({
    id: "".concat(id).concat(quantity > 1 ? (cov_1sbdg4za2().b[1][0]++, 's') : (cov_1sbdg4za2().b[1][1]++, ''))
  }, {
    nbItem: quantity
  });
};
var LegendIndicator = (cov_1sbdg4za2().s[9]++, _styledComponents.default.div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n    height: ", ";\n    width: ", ";\n    background-color: ", ";\n    display: inline-block;\n    border-radius: none;\n"])), font.sizeXs, font.sizeXs, function (props) {
  cov_1sbdg4za2().f[2]++;
  cov_1sbdg4za2().s[10]++;
  return props.color;
}));
var LegendIndicatorIcon = (cov_1sbdg4za2().s[11]++, (0, _styledComponents.default)(_icon.default)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n    color: ", ";\n    display: inline-block;\n    border-radius: 50%;\n    margin-right: 8px;\n"])), function (props) {
  cov_1sbdg4za2().f[3]++;
  cov_1sbdg4za2().s[12]++;
  return props.color;
}));
var Advantage = (cov_1sbdg4za2().s[13]++, (0, _styledComponents.default)(_icon.default).attrs({
  className: 'g-mini-calendar-content' // to force the update of the color
})(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  margin: auto;\n  ", ";\n  color: ", ";\n"])), function (props) {
  cov_1sbdg4za2().f[4]++;
  cov_1sbdg4za2().s[14]++;
  return props.legend ? (cov_1sbdg4za2().b[2][0]++, 'top: -0.1rem;') : (cov_1sbdg4za2().b[2][1]++, 'vertical-align: bottom;');
}, function (props) {
  cov_1sbdg4za2().f[5]++;
  cov_1sbdg4za2().s[15]++;
  return (cov_1sbdg4za2().b[3][0]++, props.theme) && (cov_1sbdg4za2().b[3][1]++, props.theme.advantage) && (cov_1sbdg4za2().b[3][2]++, props.theme.advantage.backgroundColor);
}));
var OccurrenceCalendar = /*#__PURE__*/function (_React$PureComponent) {
  function OccurrenceCalendar(props) {
    var _this;
    (0, _classCallCheck2.default)(this, OccurrenceCalendar);
    cov_1sbdg4za2().f[7]++;
    cov_1sbdg4za2().s[27]++;
    _this = _callSuper(this, OccurrenceCalendar, [props]);
    cov_1sbdg4za2().s[28]++;
    _this.state = {
      month: props.month
    };
    cov_1sbdg4za2().s[29]++;
    _this.changeMonth = _this.changeMonth.bind(_this);
    cov_1sbdg4za2().s[30]++;
    _this.onClickDay = _this.onClickDay.bind(_this);
    return _this;
  }

  /**
   * Called when click over a day in the MiniCalendar component
   * @param {Object} data, contains the day info
   */
  (0, _inherits2.default)(OccurrenceCalendar, _React$PureComponent);
  return (0, _createClass2.default)(OccurrenceCalendar, [{
    key: "onClickDay",
    value: function onClickDay(data) {
      cov_1sbdg4za2().f[8]++;
      cov_1sbdg4za2().s[31]++;
      this.props.onClickDay(data);
    }
  }, {
    key: "getProduct",
    value: function getProduct() {
      cov_1sbdg4za2().f[9]++;
      var section = (cov_1sbdg4za2().s[32]++, (cov_1sbdg4za2().b[8][0]++, this.props.calendar.sectionByMonth) && (cov_1sbdg4za2().b[8][1]++, this.props.calendar.sectionByMonth[(0, _format.default)(this.state.month, 'YYYY-MM')]));
      cov_1sbdg4za2().s[33]++;
      return (0, _assign.default)({}, (0, _get.default)(section, 'clusters[0].items[0].product', {}));
    }
  }, {
    key: "previousProduct",
    value: function () {
      var _previousProduct = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
        var product;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              cov_1sbdg4za2().f[10]++;
              product = (cov_1sbdg4za2().s[34]++, this.getProduct());
              cov_1sbdg4za2().s[35]++;
              this.props.changeProduct(product.previousSeasonLinkedProductId);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function previousProduct() {
        return _previousProduct.apply(this, arguments);
      }
      return previousProduct;
    }()
  }, {
    key: "nextProduct",
    value: function () {
      var _nextProduct = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var product;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              cov_1sbdg4za2().f[11]++;
              product = (cov_1sbdg4za2().s[36]++, this.getProduct());
              cov_1sbdg4za2().s[37]++;
              this.props.changeProduct(product.nextSeasonLinkedProductId);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function nextProduct() {
        return _nextProduct.apply(this, arguments);
      }
      return nextProduct;
    }()
    /*
     * When changing month check that if it is the previous or the next product
     * If so, reload the entire calendar
     */
  }, {
    key: "changeMonth",
    value: function changeMonth(monthDate) {
      cov_1sbdg4za2().f[12]++;
      var years = (cov_1sbdg4za2().s[38]++, (0, _keys.default)(this.props.calendar.months).sort());
      var firstYear = (cov_1sbdg4za2().s[39]++, Number(years[0]));
      var lastYear = (cov_1sbdg4za2().s[40]++, Number(years.pop()));
      var curYear = (cov_1sbdg4za2().s[41]++, (0, _get_year.default)(monthDate));
      var firstMonth = (cov_1sbdg4za2().s[42]++, this.props.calendar.months[firstYear][0]);
      var lastMonth = (cov_1sbdg4za2().s[43]++, this.props.calendar.months[firstYear].slice(-1)[0]);
      var curMonth = (cov_1sbdg4za2().s[44]++, (0, _get_month.default)(monthDate));
      cov_1sbdg4za2().s[45]++;
      if ((cov_1sbdg4za2().b[10][0]++, curYear < firstYear) || (cov_1sbdg4za2().b[10][1]++, curYear === firstYear) && (cov_1sbdg4za2().b[10][2]++, firstMonth > curMonth)) {
        cov_1sbdg4za2().b[9][0]++;
        cov_1sbdg4za2().s[46]++;
        this.previousProduct();
      } else {
        cov_1sbdg4za2().b[9][1]++;
        cov_1sbdg4za2().s[47]++;
        if ((cov_1sbdg4za2().b[12][0]++, curYear > lastYear) || (cov_1sbdg4za2().b[12][1]++, curYear === lastYear) && (cov_1sbdg4za2().b[12][2]++, lastMonth < curMonth)) {
          cov_1sbdg4za2().b[11][0]++;
          cov_1sbdg4za2().s[48]++;
          this.nextProduct();
        } else {
          cov_1sbdg4za2().b[11][1]++;
          cov_1sbdg4za2().s[49]++;
          this.props.changeMonth(monthDate);
          cov_1sbdg4za2().s[50]++;
          this.setState({
            month: monthDate,
            detailedDay: null
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      cov_1sbdg4za2().f[13]++;
      var _ref2 = (cov_1sbdg4za2().s[51]++, this.props),
        _ref2$currentTheme = _ref2.currentTheme,
        currentTheme = _ref2$currentTheme === void 0 ? (cov_1sbdg4za2().b[13][0]++, _themeProvider.TicketShopTheme.EQUILIBRIUM) : _ref2$currentTheme;
      var hasAdvantage = (cov_1sbdg4za2().s[52]++, false);
      var section = (cov_1sbdg4za2().s[53]++, (cov_1sbdg4za2().b[14][0]++, this.props.calendar.sectionByMonth) && (cov_1sbdg4za2().b[14][1]++, this.props.calendar.sectionByMonth[(0, _format.default)(this.state.month, 'YYYY-MM')]));
      var advantageEl = (cov_1sbdg4za2().s[54]++, /*#__PURE__*/_react.default.createElement(Advantage, {
        size: "10",
        iconName: "grade",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 183,
          columnNumber: 25
        }
      }));

      // Values that will be
      var forceBeforeMonth = (cov_1sbdg4za2().s[55]++, false);
      var forceAfterMonth = (cov_1sbdg4za2().s[56]++, false);
      // a bit ugly, we take the asumption here that we have only one product
      var product = (cov_1sbdg4za2().s[57]++, this.getProduct(section));

      // create a map of indicators by date
      var dates = (cov_1sbdg4za2().s[58]++, {});
      cov_1sbdg4za2().s[59]++;
      if (product) {
        cov_1sbdg4za2().b[15][0]++;
        var isEvent = (cov_1sbdg4za2().s[60]++, false);
        cov_1sbdg4za2().s[61]++;
        if ((cov_1sbdg4za2().b[17][0]++, product.performances) && (cov_1sbdg4za2().b[17][1]++, product.performances.length > 0)) {
          cov_1sbdg4za2().b[16][0]++;
          cov_1sbdg4za2().s[62]++;
          isEvent = true;
          cov_1sbdg4za2().s[63]++;
          section.clusters.forEach(function (cluster) {
            cov_1sbdg4za2().f[14]++;
            cov_1sbdg4za2().s[64]++;
            cluster.items.forEach(function (item) {
              cov_1sbdg4za2().f[15]++;
              cov_1sbdg4za2().s[65]++;
              product.performances = product.performances.concat(item.product.performances);
            });
          });
        } else {
          cov_1sbdg4za2().b[16][1]++;
          cov_1sbdg4za2().s[66]++;
          if ((cov_1sbdg4za2().b[19][0]++, product.timeslots) && (cov_1sbdg4za2().b[19][1]++, product.timeslots.length > 0)) {
            cov_1sbdg4za2().b[18][0]++;
            cov_1sbdg4za2().s[67]++;
            section.clusters.forEach(function (cluster) {
              cov_1sbdg4za2().f[16]++;
              cov_1sbdg4za2().s[68]++;
              cluster.items.forEach(function (item) {
                cov_1sbdg4za2().f[17]++;
                cov_1sbdg4za2().s[69]++;
                product.timeslots = product.timeslots.concat(item.product.timeslots);
              });
            });
          } else {
            cov_1sbdg4za2().b[18][1]++;
          }
        }
        var occurrences = (cov_1sbdg4za2().s[70]++, _product.ProductModel.getOccurrences(product));
        var action = (cov_1sbdg4za2().s[71]++, (cov_1sbdg4za2().b[20][0]++, product.action) && (cov_1sbdg4za2().b[20][1]++, product.action.buy));
        var firstDate;
        cov_1sbdg4za2().s[72]++;
        if (occurrences.length > 0) {
          cov_1sbdg4za2().b[21][0]++;
          cov_1sbdg4za2().s[73]++;
          firstDate = occurrences[0].start;
        } else {
          cov_1sbdg4za2().b[21][1]++;
        }
        cov_1sbdg4za2().s[74]++;
        occurrences.forEach(function (occ) {
          cov_1sbdg4za2().f[18]++;
          var start = (cov_1sbdg4za2().s[75]++, occ.start);
          var date = (cov_1sbdg4za2().s[76]++, (0, _format.default)(start.split('T')[0], 'YYYY-MM-DD'));
          var actionDate = (cov_1sbdg4za2().s[77]++, (0, _format.default)(start.split('T')[0], 'DD.MM.YYYY'));
          var previousDate = (cov_1sbdg4za2().s[78]++, dates[date]);
          var occWithAdvantage = (cov_1sbdg4za2().s[79]++, occ.withAdvantage);
          cov_1sbdg4za2().s[80]++;
          firstDate = (0, _is_before.default)(firstDate, start) ? (cov_1sbdg4za2().b[22][0]++, firstDate) : (cov_1sbdg4za2().b[22][1]++, start);
          cov_1sbdg4za2().s[81]++;
          hasAdvantage = (cov_1sbdg4za2().b[23][0]++, hasAdvantage) || (cov_1sbdg4za2().b[23][1]++, occWithAdvantage);
          cov_1sbdg4za2().s[82]++;
          if (!previousDate) {
            cov_1sbdg4za2().b[24][0]++;
            cov_1sbdg4za2().s[83]++;
            dates[date] = {
              indicator: occ.availability,
              action: (cov_1sbdg4za2().b[25][0]++, action) && (cov_1sbdg4za2().b[25][1]++, (0, _utils.buildUrl)(action, {
                date: actionDate
              })),
              content: occWithAdvantage ? (cov_1sbdg4za2().b[26][0]++, advantageEl) : (cov_1sbdg4za2().b[26][1]++, ''),
              quantity: 1,
              info: getInfo(_this2.props.intl, 1, isEvent)
            };
          } else {
            cov_1sbdg4za2().b[24][1]++;
            cov_1sbdg4za2().s[84]++;
            previousDate.quantity += 1;
            cov_1sbdg4za2().s[85]++;
            previousDate.info = getInfo(_this2.props.intl, previousDate.quantity, isEvent);
            // use the priority avail to define what color to show
            cov_1sbdg4za2().s[86]++;
            previousDate.indicator = priorityAvail[occ.availability] > priorityAvail[previousDate.indicator] ? (cov_1sbdg4za2().b[27][0]++, occ.availability) : (cov_1sbdg4za2().b[27][1]++, previousDate.indicator);
            cov_1sbdg4za2().s[87]++;
            previousDate.content = occWithAdvantage ? (cov_1sbdg4za2().b[28][0]++, advantageEl) : (cov_1sbdg4za2().b[28][1]++, previousDate.content);
          }
        });
        cov_1sbdg4za2().s[88]++;
        forceBeforeMonth = Boolean(product.previousSeasonLinkedProductId);
        cov_1sbdg4za2().s[89]++;
        forceAfterMonth = Boolean(product.nextSeasonLinkedProductId);
      } else {
        cov_1sbdg4za2().b[15][1]++;
      }
      cov_1sbdg4za2().s[90]++;
      var getLegendWrapper = function getLegendWrapper() {
        cov_1sbdg4za2().f[19]++;
        cov_1sbdg4za2().s[91]++;
        return /*#__PURE__*/_react.default.createElement(LegendWrapper, {
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 248,
            columnNumber: 9
          }
        }, /*#__PURE__*/_react.default.createElement(LegendEntry, {
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 249,
            columnNumber: 11
          }
        }, (cov_1sbdg4za2().b[29][0]++, currentTheme === _themeProvider.TicketShopTheme.EQUILIBRIUM) && (cov_1sbdg4za2().b[29][1]++, /*#__PURE__*/_react.default.createElement(LegendIndicator, {
          color: color.GOOD,
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 250,
            columnNumber: 63
          }
        })), (cov_1sbdg4za2().b[30][0]++, currentTheme === _themeProvider.TicketShopTheme.EVOLUTION) && (cov_1sbdg4za2().b[30][1]++, /*#__PURE__*/_react.default.createElement(LegendIndicatorIcon, {
          color: color.GOOD,
          iconName: "circleFill",
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 251,
            columnNumber: 61
          }
        })), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: "gravity.OccurrenceCalendar.available",
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 252,
            columnNumber: 13
          }
        })), /*#__PURE__*/_react.default.createElement(LegendEntry, {
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 254,
            columnNumber: 11
          }
        }, (cov_1sbdg4za2().b[31][0]++, currentTheme === _themeProvider.TicketShopTheme.EQUILIBRIUM) && (cov_1sbdg4za2().b[31][1]++, /*#__PURE__*/_react.default.createElement(LegendIndicator, {
          color: color.LIMITED,
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 255,
            columnNumber: 63
          }
        })), (cov_1sbdg4za2().b[32][0]++, currentTheme === _themeProvider.TicketShopTheme.EVOLUTION) && (cov_1sbdg4za2().b[32][1]++, /*#__PURE__*/_react.default.createElement(LegendIndicatorIcon, {
          color: color.LIMITED,
          iconName: "circleLine",
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 256,
            columnNumber: 61
          }
        })), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: "gravity.OccurrenceCalendar.limited",
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 257,
            columnNumber: 13
          }
        })), /*#__PURE__*/_react.default.createElement(LegendEntry, {
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 259,
            columnNumber: 11
          }
        }, (cov_1sbdg4za2().b[33][0]++, currentTheme === _themeProvider.TicketShopTheme.EQUILIBRIUM) && (cov_1sbdg4za2().b[33][1]++, /*#__PURE__*/_react.default.createElement(LegendIndicator, {
          color: color.NONE,
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 260,
            columnNumber: 63
          }
        })), (cov_1sbdg4za2().b[34][0]++, currentTheme === _themeProvider.TicketShopTheme.EVOLUTION) && (cov_1sbdg4za2().b[34][1]++, /*#__PURE__*/_react.default.createElement(LegendIndicatorIcon, {
          color: color.NONE,
          iconName: "prohibitedLine",
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 261,
            columnNumber: 61
          }
        })), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: "gravity.OccurrenceCalendar.unavailable",
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 262,
            columnNumber: 13
          }
        })), (cov_1sbdg4za2().b[35][0]++, currentTheme === _themeProvider.TicketShopTheme.EQUILIBRIUM) && (cov_1sbdg4za2().b[35][1]++, /*#__PURE__*/_react.default.createElement(LegendEntry, {
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 264,
            columnNumber: 60
          }
        })), (cov_1sbdg4za2().b[36][0]++, hasAdvantage) && (cov_1sbdg4za2().b[36][1]++, /*#__PURE__*/_react.default.createElement(LegendEntry, {
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 266,
            columnNumber: 13
          }
        }, /*#__PURE__*/_react.default.createElement(Advantage, {
          size: 12,
          iconName: "grade",
          legend: true,
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 267,
            columnNumber: 15
          }
        }), ' ', /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: "gravity.OccurrenceCalendar.advantage",
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 268,
            columnNumber: 15
          }
        }))));
      };
      cov_1sbdg4za2().s[92]++;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Wrapper, {
        productid: (cov_1sbdg4za2().b[37][0]++, product) && (cov_1sbdg4za2().b[37][1]++, product.id),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 277,
          columnNumber: 9
        }
      }, /*#__PURE__*/_react.default.createElement(_calendar.MiniCalendar, {
        month: this.state.month,
        days: dates,
        onMonthChange: this.changeMonth,
        months: this.props.calendar.months,
        forceBeforeMonth: forceBeforeMonth,
        forceAfterMonth: forceAfterMonth,
        onClick: this.props.onClickDay ? (cov_1sbdg4za2().b[38][0]++, this.onClickDay) : (cov_1sbdg4za2().b[38][1]++, undefined),
        selectedDay: this.props.selectedDay,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 278,
          columnNumber: 11
        }
      }), (cov_1sbdg4za2().b[39][0]++, !this.props.hideLegend) && (cov_1sbdg4za2().b[39][1]++, currentTheme === _themeProvider.TicketShopTheme.EQUILIBRIUM) && (cov_1sbdg4za2().b[39][2]++, getLegendWrapper())), (cov_1sbdg4za2().b[40][0]++, !this.props.hideLegend) && (cov_1sbdg4za2().b[40][1]++, currentTheme === _themeProvider.TicketShopTheme.EVOLUTION) && (cov_1sbdg4za2().b[40][2]++, getLegendWrapper()));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      cov_1sbdg4za2().f[6]++;
      cov_1sbdg4za2().s[16]++;
      // check if the date is in the rage and change if needed.
      if ((cov_1sbdg4za2().b[5][0]++, props.calendar) && (cov_1sbdg4za2().b[5][1]++, props.calendar.months)) {
        cov_1sbdg4za2().b[4][0]++;
        var years = (cov_1sbdg4za2().s[17]++, (0, _keys.default)(props.calendar.months).sort());
        var firstYear = (cov_1sbdg4za2().s[18]++, years[0]);
        var lastYear = (cov_1sbdg4za2().s[19]++, years.pop());
        var firstMonth = (cov_1sbdg4za2().s[20]++, new Date(firstYear, props.calendar.months[firstYear][0]));
        cov_1sbdg4za2().s[21]++;
        if ((0, _is_before.default)(state.month, firstMonth)) {
          cov_1sbdg4za2().b[6][0]++;
          cov_1sbdg4za2().s[22]++;
          return _objectSpread(_objectSpread({}, state), {}, {
            month: firstMonth
          });
        } else {
          cov_1sbdg4za2().b[6][1]++;
        }
        var lastMonth = (cov_1sbdg4za2().s[23]++, new Date(lastYear, props.calendar.months[lastYear].slice(-1)[0]));
        cov_1sbdg4za2().s[24]++;
        if ((0, _is_before.default)(lastMonth, state.month)) {
          cov_1sbdg4za2().b[7][0]++;
          cov_1sbdg4za2().s[25]++;
          return _objectSpread(_objectSpread({}, state), {}, {
            month: lastMonth
          });
        } else {
          cov_1sbdg4za2().b[7][1]++;
        }
      } else {
        cov_1sbdg4za2().b[4][1]++;
      }
      cov_1sbdg4za2().s[26]++;
      return state;
    }
  }]);
}((_react.default.PureComponent));
cov_1sbdg4za2().s[93]++;
OccurrenceCalendar.propTypes = {
  /** Action to call when the monthChange */
  changeMonth: _propTypes.default.func,
  /** Action to call when the product change. The main */
  changeProduct: _propTypes.default.func,
  /* The product object to display */
  calendar: _calendar2.CalendarType.isRequired,
  /* The default month to show */
  month: _propTypes.default.date,
  /* intl is set by injection */
  intl: _reactIntl.intlShape.isRequired,
  /* allows to hide the legend on the right */
  hideLegend: _propTypes.default.bool,
  /**
   * Action to call when a day is selected
   */
  onClickDay: _propTypes.default.func,
  /**
   * A day selected for which we want to have more details it has the format YYYY-MM-DD
   */
  selectedDay: _propTypes.default.string,
  /** theme context */
  currentTheme: _propTypes.default.string,
  theme: _propTypes.default.shape({})
};
cov_1sbdg4za2().s[94]++;
OccurrenceCalendar.defaultProps = {
  changeMonth: undefined,
  changeProduct: undefined,
  month: new Date(),
  hideLegend: false,
  onClickDay: undefined,
  selectedDay: undefined,
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  currentTheme: _themeProvider.DEFAULT_THEME_CONTEXT.theme,
  theme: {}
};

// TODO : ensure that documentation is ok with
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)((0, _reactIntl.injectIntl)(OccurrenceCalendar)));